import { useState } from 'react';
import { isImageExtension } from '../fileItemUtils';
import { showToast } from '../../ui/feedback';

export const useFilePreview = (fileExtension: string) => {
  const [showCropTool, setShowCropTool] = useState(false);
  const [loadingCropTool, setLoadingCropTool] = useState(false);
  const [cropImage, setCropImage] = useState<any>('');
  const [modalImage, setModalImage] = useState<any>('');
  const [showImageModal, setShowImageModal] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);

  const openCropTool = async (id: number) => {
    setLoadingCropTool(true);

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const storedJWT = localStorage.getItem('jwt');
    try {
      const headers = {
        'Content-Type': 'application/json',
        ...(storedJWT && { Authorization: 'Bearer ' + storedJWT }),
      };
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/get-cropper-image.php`,
        {
          method: 'POST',
          mode: 'cors',
          headers,
          body: JSON.stringify({
            id,
            email: user.email || null,
          }),
        }
      );

      const data = await response.json();

      if (data.base64) {
        setCropImage(data.base64);
        setShowCropTool(true);
      } else {
        showToast({ message: 'No image found', variant: 'warning' });
      }
      setLoadingCropTool(false);
    } catch (error) {
      console.error('Error:', error);
      setLoadingCropTool(false);
      return null;
    }
  };

  const openModalImage = async (id: number) => {
    if (!isImageExtension(fileExtension)) {
      return;
    }
    setLoadingModal(true);
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const storedJWT = localStorage.getItem('jwt');
    try {
      const headers = {
        'Content-Type': 'application/json',
        ...(storedJWT && { Authorization: 'Bearer ' + storedJWT }),
      };
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/get-modal-image.php`,
        {
          method: 'POST',
          mode: 'cors',
          headers,
          body: JSON.stringify({
            id,
            email: user.email || null,
          }),
        }
      );

      const data = await response.json();

      if (data.base64) {
        setModalImage(data);
        setShowImageModal(true);
      } else {
        showToast({ message: 'No image found', variant: 'warning' });
      }
      setLoadingModal(false);
    } catch (error) {
      console.error('Error:', error);
      setLoadingModal(false);
      return null;
    }
  };

  const closeCropTool = () => {
    setShowCropTool(false);
  };

  return {
    showCropTool,
    loadingCropTool,
    cropImage,
    modalImage,
    showImageModal,
    loadingModal,
    setShowImageModal,
    openCropTool,
    openModalImage,
    closeCropTool,
  };
};
